<template>
  <div class="mrgn-top">
       <v-flex class="space1"></v-flex>
    <sequential-entrance fromBottom delay="500" >
    <template v-for="(item, index) in items">
      <v-list-item two-line :key="index">
        <v-list-item-content>
          <v-list-item-title>{{item.title}}</v-list-item-title>
          <v-list-item-subtitle>Command : {{item.explanation}}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </template>
    </sequential-entrance>
  </div>
</template>

<script>
export default {
  name: "command assistant",
  components: {},
  data() {
    return {
      items: [
        {
          title: "Find/Search in google",
          explanation: "Google News about Tesla",
        },
        {
          title: "Starts an Inventory Form",
          explanation: "Create a Form",
        },
        {
          title: "Starts a New Quote",
          explanation: "Create a Quote",
        },
        {
          title: "Ask to show your Sales Reports, Emails, Tasks, Calendar",
          explanation: "Show my sales reports/emails/task/calendar",
        },

        {
          title: "Navigate to Screen by Voice command",
          explanation: "Navigate to Dashboard",
        },
      ],
    };
  },
};
</script>

<style scoped>
.space {
  height: 100px;
}
.space1 {
  height: 30px;
}
.mrgn-top {
  text-align: center;
}
.center-aligned {
  text-align: center;
  color: rgb(58, 57, 57);
}
h3 {
  color: #888;
}
</style>
